import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '@/shared/components/loader/services/loader.service';

/**
 * Interceptor HTTP que mostra/esconde o loader global automaticamente
 * para todas as requisições HTTP da aplicação.
 */
export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);

  // Mostra o loader antes da requisição
  loaderService.show();

  // Processa a requisição e esconde o loader quando finalizar
  return next(req).pipe(
    finalize(() => {
      // Esconde o loader após a requisição (sucesso ou erro)
      loaderService.hide();
    })
  );
};

